import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { SuggestionsSearchProvider } from "../suggestions.search.provider";

@Injectable()
export class DemoSuggestionsSearchProvider extends SuggestionsSearchProvider {
  constructor() {
    super();
  }

  // this is the query to be used when nothing is known about user intentions
  // hence we just search the db for most popular terms - whatever they are.
  public searchForMostPopular(): Observable<any> {
    return of([{ value: "123" }, { value: "456" }, { value: "789" }]);
  }

  // this is a method to use when user types in one or  more characters. we assume
  // those characters represent 'value' without being bound to specific 'category'
  // the query should return most popular 'values' in all 'categories'.
  public searchForSuggestions(term: string): Observable<any> {
    return of([{ value: `"12${term}34"` }, { value: `"56${term}8"` }]);
  }

  // this is a query to use when 'category' is known. If term is not given, we shall
  // return most popular 'values' within that 'category'. If term is given,
  // then top N matching 'values' within 'category' will be returned.
  public searchForSuggestionsInCategory(category:string, term?: string): Observable<any> {
    return of([{ value: `"aaa${term}bb"` }, { value: `"cc${term}dd"` }]);
  }
}
